module.exports = __webpack_public_path__ + "static/media/CaixaLivre1.3e23ada1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancCaixaLivre/CaixaLivre1.png
// module id = 2043
// module chunks = 0